<div class="new-group-container">
  <!-- Text input field for filtering -->
  <mat-form-field appearance="outline">
    <mat-label>Crea nuovo gruppo</mat-label>
    <input matInput [(ngModel)]="newGroupName" />
  </mat-form-field>

  <button mat-flat-button [disabled]="!newGroupName" (click)="onSubmit()">
    Crea
  </button>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Group</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let element" class="flex-cell">
      <button mat-mini-fab (click)="onDeleteClick(element.name)">
        <mat-icon color="warn">delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Righe della tabella -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="flex-row"
  ></tr>
</table>
